import React from "react";
import { Input } from "antd";
import Error from "theme/Error";

import "./index.less";

const { TextArea } = Input;

const GiftCardForm = ({ setFormData, formData, formDataErrors }) => {
  return (
    <form className="gift-card-form">
      <h4>Ik wil de cadeaubon</h4>
      <div className="gift-card-form__item">
        <p className="gift-card-form__label">Naam afzender*</p>
        <Input
          label="Buyer Full Name"
          name="buyerFullName"
          type="text"
          required
          onChange={(e) =>
            setFormData({ ...formData, buyerFullName: e.target.value })
          }
        />
        <Error data={formDataErrors} field="buyerFullName" />
      </div>
      <div className="gift-card-form__item">
        <p className="gift-card-form__label">
          E-mailadres naar waar de giftcard wordt verstuurd*
        </p>
        <Input
          name="personToBeGiftedEmail"
          type="email"
          required
          onChange={(e) =>
            setFormData({ ...formData, personToBeGiftedEmail: e.target.value })
          }
        />
        <Error data={formDataErrors} field="personToBeGiftedEmail" />
      </div>
      <div className="gift-card-form__item">
        <p className="gift-card-form__label">Naam geadresseerde</p>
        <Input
          name="personToBeGiftedName"
          type="text"
          onChange={(e) =>
            setFormData({ ...formData, personToBeGiftedName: e.target.value })
          }
        />
      </div>
      <div className="gift-card-form__item">
        <p className="gift-card-form__label">Bericht</p>
        <TextArea
          name="message"
          onChange={(e) =>
            setFormData({ ...formData, message: e.target.value })
          }
        />
      </div>
    </form>
  );
};

export default GiftCardForm;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/product/giftCardForm/index.js